"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var identity = require('lodash/identity');

var pickBy = require('lodash/pickBy');

var request = require('@flowio/request');

var retry = require('@flowio/request/lib/with-retry');

var OrganizationSessionClient = /*#__PURE__*/function () {
  function OrganizationSessionClient(_ref) {
    var apiBaseUri = _ref.apiBaseUri;

    _classCallCheck(this, OrganizationSessionClient);

    this.apiBaseUri = apiBaseUri;
  }

  _createClass(OrganizationSessionClient, [{
    key: "createSession",
    value: function createSession(organizationId, callback) {
      retry(request.anonymous, {
        haltOnStatus: [422, 404]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/organizations/").concat(organizationId),
        data: {},
        method: 'POST',
        envelope: true
      }, callback);
    }
  }, {
    key: "getSession",
    value: function getSession(sessionId, callback) {
      retry(request.anonymous, {
        haltOnStatus: [422, 404]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/").concat(sessionId),
        method: 'GET'
      }, callback);
    }
  }, {
    key: "resetSession",
    value: function resetSession(sessionId, form, callback) {
      retry(request.anonymous, {
        haltOnStatus: [404, 422]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/").concat(sessionId, "/reset"),
        method: 'PUT',
        data: pickBy(form, identity),
        envelope: true
      }, callback);
    }
  }, {
    key: "clearSession",
    value: function clearSession(sessionId, callback) {
      retry(request.anonymous, {
        haltOnStatus: [404, 422]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/").concat(sessionId, "/clear"),
        method: 'PUT',
        data: {},
        envelope: true
      }, callback);
    }
  }]);

  return OrganizationSessionClient;
}();

module.exports = OrganizationSessionClient;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/client/organization.js
// module id = 690
// module chunks = 0 1